/* eslint-disable no-unused-vars */
import { gameState } from '@js/state';

let sound = true;
let settings = false;
let interacted = false;
let call = 0;
let slideDown;
let animsList = [];
let value = 0;
let round = 0;
let rect;
let circX = 530;
let bar = [];

export default class HintScene extends Phaser.Scene {
  constructor() {
    super({ key: 'HintScene' });
  }

  preload() {}

  create() {
    this.timesclicked = 0;

    this.hintAnimations();
    this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0).setAlpha(0);

    this.hintText = this.add.image(72, 656, 'hintText').setOrigin(0, 1).setScale(0);

    this.hintButton = this.physics.add
      .sprite(-25, 550, 'hintFinalAnim')
      .setOrigin(0)
      .setScale(0.8)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    this.hintButton.on('pointerdown', () => {
      if (gameState.attempts == 1) {
        this.hintText.setTexture('hintText');
        this.hintClose.y = 406;
      } else {
        this.hintText.setTexture('hintText2');
        this.hintClose.y = 486;
      }

      this.teraThinkLoop.setVisible(false);
      this.teraIdea.setVisible(true);
      this.teraIdea.anims.play('teraIdea');
      this.teraIdea.on(
        Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'teraIdea',
        () => {
          this.teraIdea.setVisible(false);
          this.teraThinkLoop.setAlpha(0);
          this.teraIdle.setVisible(true);
          this.teraIdle.anims.play('teraIdle');
        },
      );

      gameState.hints++;
      this.hintButton.play('idle');
      this.scene.pause('GameScene');
      this.overlay.setAlpha(1);

      this.tweens.add({
        targets: [this.hintText],
        scale: 1,
        duration: 500,
        ease: 'Sine.easeInOut',
        onComplete: () => {
          this.hintClose.setAlpha(1);
        },
      });
    });

    this.hintClose = this.add
      .image(516, 406, 'hintClose')
      .setOrigin(0)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.hintClose.on('pointerdown', () => {
      this.teraIdea.setVisible(false);
      this.teraThinkLoop.setVisible(true);
      this.scene.resume('GameScene');
      this.overlay.setAlpha(0);
      this.hintText.setScale(0);
      this.hintClose.setAlpha(0);
    });

    this.bar = this.add.image(0, 0, 'mask').setOrigin(0);
    this.shape = this.make.graphics();
    this.shape.beginPath();
    this.shape.fillRect(0, 75, 1280, 150);
    this.mask = this.shape.createGeometryMask();

    this.dropDown = this.add.image(1220, 145, 'dropDown').setOrigin(0.5, 0.5);
    this.sound = this.add
      .image(1220, 132, 'sound')
      .setOrigin(0.5, 0.5)
      .setDepth(2)
      .setScale(0.75)
      .setInteractive({ cursor: 'pointer' });
    this.fullScreenOff = this.add
      .image(1220, 185, 'fullScreenOff')
      .setDepth(2)
      .setOrigin(0.5, 0.5)
      .setScale(0.73)
      .setInteractive({ cursor: 'pointer' });

    this.progressBar = this.add.image(516, 8, 'progressBar').setOrigin(0);

    this.animCreate('teraIn', 'teraIn', 0, 30, 'teraIn', 30, 0);
    animsList.push('teraIn');
    this.animCreate('teraIdle', 'teraIdle', 0, 40, 'teraIdleBlink', 24, -1, 0);
    animsList.push('teraIdle');
    this.animCreate('teraCorrect', 'teraCorrect', 0, 111, 'teraCorrect', 30, 0);
    animsList.push('teraCorrect');
    this.animCreate('teraWrong', 'teraWrong', 0, 114, 'teraWrong', 30, 0);
    animsList.push('teraWrong');
    this.animCreate('teraThinkStart', 'teraThink', 0, 30, 'teraThink', 30, 0);
    animsList.push('teraThinkStart');
    this.animCreate('teraThinkLoop', 'teraThink', 31, 90, 'teraThink', 30, -1, 0, true);
    animsList.push('teraThinkLoop');
    this.animCreate('teraThinkLoopReverse', 'teraThink', 90, 31, 'teraThink', 30, 0);
    animsList.push('teraThinkLoopReverse');
    this.animCreate('teraThinkOut', 'teraThink', 91, 111, 'teraThink', 30, 0);
    animsList.push('teraThinkOut');
    this.animCreate('teraIdea', 'teraIdea', 0, 82, 'teraIdea', 30, 0);
    animsList.push('teraIdea');
    this.animCreate('teraOut', 'teraOut', 0, 25, 'teraOut', 30, 0);
    animsList.push('teraOut');

    this.holder = this.add.image(70, 42, 'holder').setOrigin(0);
    this.holder.displayWidth = 0;
    this.q = this.add.image(168, 90, 'T1').setOrigin(0, 0.5).setAlpha(0);
    this.teraIn = this.add.sprite(75, 93, 'teraIn').play('teraIn');
    this.teraIdle = this.add.sprite(75, 93, 'teraIdle').setVisible(false);
    this.teraCorrect = this.add.sprite(75, 93, 'teraCorrect').setVisible(false);
    this.teraWrong = this.add.sprite(75, 93, 'teraWrong').setVisible(false);
    this.teraThinkStart = this.add.sprite(75, 93, 'teraThinkStart').setVisible(false);
    this.teraThinkLoop = this.add.sprite(75, 93, 'teraThinkLoop').setVisible(false);
    this.teraThinkOut = this.add.sprite(75, 93, 'teraThinkOut').setVisible(false);
    this.teraIdea = this.add.sprite(75, 93, 'teraIdea').setVisible(false);
    this.teraOut = this.add.sprite(75, 93, 'teraOut').setVisible(false);

    this.textHolderTween(1002, 500, 50);
    rect = this.add.rectangle(535, 18, 1, 5, 0xffcf56, 1).setOrigin(0);

    this.paused = this.add
      .image(0, 0, 'paused')
      .setDepth(2)
      .setOrigin(0)
      .setVisible(false);

    this.container = this.add
      .container(0, -130, [this.dropDown, this.sound, this.fullScreenOff])
      .setDepth(2);
    this.container.setMask(this.mask);

    this.yellow = this.add.image(1220, 72, 'yellow').setDepth(2).setOrigin(0.5, 0.5);
    this.circle = this.add
      .image(1220, 72, 'circle')
      .setDepth(2)
      .setOrigin(0.5, 0.5)
      .setInteractive({ cursor: 'pointer' });

    this.animCreate('pause', 'playAnim', 21, 21, 'playPause', 30, 0);
    this.animCreate('pausePlay', 'playAnim', 21, 39, 'playPause', 30, 0);

    this.pause = this.add
      .sprite(1125, 72, 'playAnim')
      .setDepth(2)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true })
      .play('pause');
    this.pause.on('pointerup', () => {
      if (this.paused.visible == false) {
        this.pause.anims.play('pausePlay');
        this.scene.pause('GameScene');
        this.hintButton.disableInteractive();
        for (let i = 0; i < animsList.length; i++)
          this.anims.get(animsList[i]).pause();
        this.game.sound.pauseAll();
        this.paused.setVisible(true);
      } else {
        this.scene.resume('GameScene');
        this.hintButton.setInteractive();
        for (let i = 0; i < animsList.length; i++)
          this.anims.get(animsList[i]).resume();
        this.game.sound.resumeAll();
        this.pause.anims.playReverse('pausePlay', true);
        this.paused.setVisible(false);
      }
    });

    this.circle.on('pointerup', () => {
      settings = true;
      if (settings == true && this.container.y == -130) {
        settings = false;
        this.buttonScale(this.yellow, 0.9, 200, 50, 0);
        this.whiteCircleTween(60);
        this.time.delayedCall(200, () => this.menuSlideDown(0));
      }
      if (settings == true && this.container.y == 0) {
        settings = false;
        this.buttonScale(this.yellow, 0.97, 75, 10, 0);
        this.buttonScale(this.dropDown, 0.97, 75, 10, 0);
        this.whiteCircleTween(-60);
        this.time.delayedCall(200, () => this.menuSlideDown(-130));
      }
    });

    this.sound.on('pointerup', () => {
      sound = true;
      interacted = true;
      this.buttonScale(this.sound, 0.85, 75, 10, 0);
      if (this.game.sound.mute == false && sound == true) {
        this.game.sound.setMute(true);
        this.sound.setTexture('mute');
        sound = false;
      }
      if (this.game.sound.mute == true && sound == true) {
        this.game.sound.setMute(false);
        this.sound.setTexture('sound');
        sound = false;
      }
    });

    this.fullScreenOff.on('pointerup', () => {
      interacted = true;
      this.buttonScale(this.fullScreenOff, 0.83, 75, 10, 0);
      if (this.scale.isFullscreen) {
        this.scale.stopFullscreen();
        this.fullScreenOff.setTexture('fullScreen');
      } else {
        this.scale.startFullscreen();
        this.fullScreenOff.setTexture('fullScreenOff');
      }
    });
  }

  settingsAutoCollapse() {
    this.time.delayedCall(5000, () => {
      if (interacted == false) this.menuSlideDown(-130);
      if (interacted == true) call = 0;
    });
  }

  buttonScale(object, scale, duration, delay, repeat) {
    this.tweens.add({
      targets: object,
      scale: scale,
      ease: 'Sine.easeInOut',
      duration: duration,
      delay: delay,
      repeat: repeat,
      yoyo: true,
    });
  }

  menuSlideDown(y) {
    slideDown = this.tweens.add({
      targets: this.container,
      y: y,
      ease: 'Linear',
      duration: 500,
      delay: 100,
      repeat: 0,
      onComplete: () => {
        if (y == 0) call = 0;
      },
    });
  }

  whiteCircleTween(angle) {
    this.tweens.add({
      targets: [this.circle],
      x: 1219,
      y: 70,
      ease: 'Sine.easeInOut',
      duration: 75,
      delay: 10,
      repeat: 0,
      yoyo: true,
      onComplete: () => {
        this.tweens.add({
          targets: [this.circle],
          angle: angle,
          ease: 'Power1',
          duration: 500,
          delay: 25,
          repeat: 0,
        });
      },
    });
  }

  animCreate(key, frames, start, end, prefix, frameRate, repeat, repeatDelay = 0, yoyo = false) {
    this.anims.create({
      key,
      frames: this.anims.generateFrameNames(frames, { start, end, prefix, suffix: '.png' }),
      frameRate,
      repeat,
      yoyo,
      repeatDelay,
    });
  }

  textHolderTween(width, duration, delay) {
    this.tweens.add({
      targets: this.holder,
      displayWidth: width,
      ease: 'Sine.easeInOut',
      duration: duration,
      delay: delay,
      repeat: 0,
      onComplete: () => {
        this.time.delayedCall(200, () => {
          if (width == 1002) {
            if (gameState.questionNumber >= 1) {
              this.q.setTexture('Q' + gameState.questionNumber);
            }
            this.objectFadeInOut(1, 1000, 250);
          }

          if (gameState.correct == 6 || gameState.questionNumber >= 10) {
            this.teraOut.setVisible(true);
            this.teraOut.play('teraOut');
            this.teraCorrect.setVisible(false);
            this.teraIdle.setVisible(false);
            this.teraWrong.setVisible(false);
          }
        });
      },
    });
  }

  objectFadeInOut(alpha, duration, delay) {
    this.tweens.add({
      targets: this.q,
      alpha: alpha,
      ease: 'Cubic',
      duration: duration,
      delay: delay,
      repeat: 0,
      onComplete: () => {
        if (alpha == 1) {
          this.teraIn.setVisible(false);
          this.teraThinkLoop.setVisible(false);
          this.teraThinkOut.setVisible(false);
          this.teraWrong.setVisible(false);
          this.teraIdea.setVisible(false);
          this.teraIdle.setVisible(true);
          this.teraIdle.anims.play('teraIdle');
        }
        this.time.delayedCall(200, () => {
          if (alpha == 0) this.textHolderTween(0, 500, 50);
        });
      },
    });
  }

  yellowCircleDraw() {
    this.circle1 = new Phaser.Geom.Circle(circX, 21, 6);
    bar.push(this.circle1);
    this.yellow1 = this.add.graphics({ fillStyle: { color: 0xffdc83, alpha: 1 } });
    this.yellow1.fillCircleShape(this.circle1);
  }

  hintAnimations() {
    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0, end: 35, zeroPad: 0, prefix: 'seq_0_', suffix: '.png',
      }),
      frameRate: 30, repeat: 0,
    });
    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36, end: 66, zeroPad: 0, prefix: 'seq_0_', suffix: '.png',
      }),
      frameRate: 30, repeat: -1,
    });
    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36, end: 37, zeroPad: 0, prefix: 'seq_0_', suffix: '.png',
      }),
      frameRate: 1, repeat: -1,
    });
    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35, end: 0, zeroPad: 0, prefix: 'seq_0_', suffix: '.png',
      }),
      frameRate: 60, repeat: 0,
    });
  }

  clickProgress() {
    if (round < 6) {
      if (round == 0) this.yellowCircleDraw();
      round++;
      if (round == 2) circX += 47;
      if (round >= 3) circX += 43;
    }
  }

  changeText() {
    this.q.setTexture('T2').setAlpha(0);
    this.tweens.add({
      targets: this.q,
      alpha: 1,
      ease: 'Cubic',
      duration: 1000,
      delay: 250,
      repeat: 0,
    });
  }

  clickCorrect() {
    this.q.setTexture('T3');
    if (
      this.teraThinkLoop.anims.isPlaying &&
      this.teraThinkLoop.anims.currentAnim.key == 'teraThinkLoop'
    ) {
      this.teraThinkLoop.setAlpha(0);
      this.teraThinkOut.setVisible(true);
      this.teraThinkOut.anims.play('teraThinkOut');

      this.time.delayedCall(1000, () => {
        this.teraThinkOut.setVisible(false);
        this.teraCorrect.setVisible(true);
        this.teraCorrect.anims.play('teraCorrect');
      });
    } else if (
      this.teraIdle.anims.isPlaying &&
      this.teraIdle.anims.currentAnim.key == 'teraIdle'
    ) {
      this.teraIdle.setVisible(false);
      this.teraCorrect.setVisible(true);
      this.teraCorrect.anims.play('teraCorrect');
    }

    this.time.delayedCall(5000, () => {
      this.teraCorrect.setVisible(false);
      this.teraIdle.setVisible(true);
      this.objectFadeInOut(0, 1000, 250);
    });
  }

  clickWrong() {
    this.teraIdle.setVisible(false);
    this.teraThinkLoop.setVisible(false);
    this.teraWrong.setVisible(true);
    this.teraWrong.anims.play('teraWrong');

    if (gameState.attempts < 2 && gameState.attempts >= 0) {
      this.time.delayedCall(4000, () => {
        this.teraWrong.setVisible(false);
        this.teraThinkStart.setVisible(true);
        this.teraThinkStart.anims.play('teraThinkStart');
      });
      this.time.delayedCall(5000, () => {
        this.teraThinkStart.setVisible(false);
        this.teraThinkLoop.setVisible(true);
        this.teraThinkLoop.setAlpha(1);
        this.teraThinkLoop.anims.play('teraThinkLoop');
      });
    }
  }

  update() {
    if (gameState.attempts == 0) {
      this.hintButton.setVisible(false);
    }
    if (gameState.hneed && gameState.attempts > 0) {
      gameState.hneed = false;

      if (gameState.attempts == 1) {
        this.hintButton.setVisible(true);
        this.hintButton.play('pop');
        this.time.delayedCall(600, () => this.hintButton.play('breathe'));
      } else {
        this.hintButton.setVisible(true);
        this.time.delayedCall(200, () => this.hintButton.play('breathe'));
      }
    }

    if (gameState.hintClose) {
      gameState.hintClose = false;
      this.hintButton.play('pop_out');
    }

    if (round == 2) {
      if (value < 37) value += 1;
      if (value == 37) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 3) {
      if (value < 80) value += 1;
      if (value == 80) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 4) {
      if (value < 123) value += 1;
      if (value == 123) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 5) {
      if (value < 166) value += 1;
      if (value == 166) {
        this.yellowCircleDraw();
        value++;
      }
    }
    if (round == 6) {
      if (value < 209) value += 1;
      if (value == 209) {
        this.yellowCircleDraw();
        value++;
        round++;
      }
    }

    rect.setDisplaySize(1 * value, 5);
    if (round == 7) {
      this.time.delayedCall(500, () => {
        rect.setFillStyle(0x3dd771, 1);
        this.green = this.add.graphics({ fillStyle: { color: 0x3dd771, alpha: 1 } });
        for (let i = 0; i < bar.length; i++) {
          this.green.fillCircleShape(bar[i]);
          if (i == 5) {
            round = 8;
          }
        }
      });
    }

    if (this.container.y == 0 && call == 0) {
      call++;
      this.settingsAutoCollapse();
      interacted = false;
    }
  }
}
